import Styles from './MobileFooter.module.scss'
import { PostOptionsPage } from './Types'
import { usePostPreviewContext } from './PostPreviewContext'
import { ReminderButtons } from './ReminderButtons'
import { PostDetailsButtons } from './PostDetailsButtons'
import { DesignChannel } from 'components/NewFileModal/Types'
import { SchedulingButtons } from './SchedulingButtons'

interface Props {
  fileId: string
  channel: DesignChannel
}

export const MobileFooter = ({ fileId, channel }: Props) => {
  const { page } = usePostPreviewContext()

  return (
    <div className={Styles.footerContainer}>
      {page === PostOptionsPage.PostDetails && <PostDetailsButtons fileId={fileId} channel={channel} />}
      {page === PostOptionsPage.Reminder && <ReminderButtons />}
      {page === PostOptionsPage.Schedule && <SchedulingButtons fileId={fileId} channel={channel} />}
    </div>
  )
}
